import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { getNestedError } from "../../../utils";

const MyTextArea = (props) => {
  const {
    name,
    hint = "",
    debounce = 0,
    icon,
    onChange = () => {},
    onBlur = () => {},
    dense = false,
    resize = true,
    ...rest
  } = props;

  const [isFocus, setIsFocus] = useState(false);

  const {
    register,
    setValue,
    watch,
    trigger,
    clearErrors,
    formState: { errors },
  } = useFormContext();

  const value = watch(name);

  const useDebounce = (callback, delay) => {
    let timeout;
    return (...args) => {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback(...args);
      }, delay);
    };
  };

  const debouncedOnChange = useDebounce((value) => {
    setValue(name, value);
    onChange(value);
  }, debounce);

  const handleChange = (e) => {
    let newValue = e.target.value;

    debouncedOnChange(newValue);
  };

  useEffect(() => {
    if (value) trigger(name);
    else clearErrors(name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  return (
    <div>
      <div
        className={`border rounded flex items-center gap-2 ${
          !rest.disabled ? "bg-white" : "bg-[#F5F5F5]"
        } ${
          getNestedError(errors, name)
            ? "border-error"
            : isFocus
            ? "border-primary"
            : "border-gray-border"
        }`}
        style={{
          transition: "all 0.2s ease",
        }}
      >
        <textarea
          {...rest}
          {...register(name)}
          className={`flex-1 border-none outline-none bg-transparent small-scroll px-1 ${
            !dense ? "text-base" : "text-sm"
          } ${resize ? "" : "resize-none"}`}
          onFocus={() => setIsFocus(true)}
          onBlur={() => {
            setIsFocus(false);
            onBlur();
          }}
          onChange={handleChange}
        />
        {icon && icon}
      </div>
      {(getNestedError(errors, name) || hint) && (
        <p
          className={`text-sm ${
            getNestedError(errors, name) ? "text-error" : "text-[#999]"
          }`}
        >
          {getNestedError(errors, name)
            ? getNestedError(errors, name).message
            : hint}
        </p>
      )}
    </div>
  );
};

export default MyTextArea;
